import request from "@/axios";

/**
 * IM推送相关API
 */

/**
 * 推送IM消息
 * @param {Object} data - 推送数据
 * @param {number} data.appid - 渠道ID
 * @param {string} data.uid - UID列表，多个用逗号分隔
 * @returns {Promise}
 */
export function pushImMessage(data) {
  return request({
    url: "/lebo-addition/web/imPush/push",
    method: "post",
    data
  });
}

/**
 * 分页查询推送记录
 * @param {Object} params - 查询参数
 * @param {number} params.appid - 渠道ID（可选）
 * @param {string} params.uid - UID（可选）
 * @param {number} params.status - 状态（可选，0=失败，1=成功）
 * @param {number} params.current - 当前页
 * @param {number} params.size - 每页条数
 * @returns {Promise}
 */
export function getImPushRecords(params) {
  return request({
    url: "/lebo-addition/web/imPush/records",
    method: "get",
    params
  });
}
